<template>
	<form @submit.prevent="simpanData">
		<div class="card-body vl-parent" ref="formUnggah">
			<div class="row row-cols-auto justify-content-md-between justify-content-end mb-2 mx-auto gap-2">
				<div class="col-12 col-md-auto p-0 d-inline-flex">
					<h5 class="my-auto">Unggah Berkas Pendaftar</h5>
				</div>
				<div class="col-auto p-0" v-if="adminKhusus">
					<select class="form-select form-select-sm shadow-sm" v-model="ta">
						<option v-for="t in listTa" :key="t" :value="t">{{ t.nama }}</option>
					</select>
				</div>
				<div class="col-auto p-0" v-else>
					<h6 class="bg-white rounded px-2 py-1 shadow my-auto">{{ ta.nama }}</h6>
				</div>
			</div>
			<div class="row mb-2">
				<label class="col-sm-4 col-md-3 col-lg-2 col-form-label col-form-label-sm">Pendaftar</label>
				<div class="col-sm-7 col-lg-5">
					<v-select class="bg-white rounded shadow" v-model="pendaftar" placeholder="Pendaftar" label="no_reg_nama" :options="listPendaftar">
						<template #search="{ attributes, events }">
							<input class="vs__search" :required="!pendaftar" v-bind="attributes" v-on="events" />
						</template>
						<template #option="option">
							<strong>({{ option.no_reg }})</strong> {{ option.nama }}
						</template>
						<template #no-options>Pendaftar tidak ditemukan.</template>
					</v-select>
				</div>
			</div>
			<div v-show="pendaftar" class="vl-parent" ref="formField">
				<div class="row row-cols-auto mb-2">
					<label class="col-sm-4 col-md-3 col-lg-2 col-form-label col-form-label-sm">Kelengkapan</label>
					<div class="col-auto">
						<strong class="form-control form-control-sm form-control-plaintext ps-2" :style="'color:' + warna"> {{ kelengkapan }}% </strong>
					</div>
				</div>
				<div class="row mb-2">
					<label class="col-sm-4 col-md-3 col-lg-2 col-form-label col-form-label-sm">Foto Diri</label>
					<div class="col-sm-6 col-lg-4">
						<div class="input-group input-group-sm shadow">
							<input
								type="file"
								ref="fotoDiriRef"
								class="form-control form-control-sm"
								accept="image/*"
								@change="handleInputFoto($event, 'fotoDiri')"
								:disabled="loadingInput.fotoDiri" />
							<span class="input-group-text" v-show="loadingInput.fotoDiri">
								<span class="spinner-border spinner-border-sm text-secondary"></span>
							</span>
						</div>
						<img
							v-show="previews.fotoDiri"
							:src="previews.fotoDiri"
							style="max-width: 100%; max-height: 160px"
							class="mt-2 shadow btn btn-outline-secondary p-1"
							alt=""
							data-bs-toggle="modal"
							data-bs-target="#lihatFoto"
							@click="lihatFoto = previews.fotoDiri"
							v-tooltip="'Lihat Foto'" />
					</div>
				</div>
				<div class="row mb-2">
					<label class="col-sm-4 col-md-3 col-lg-2 col-form-label col-form-label-sm">Kartu Keluarga</label>
					<div class="col-sm-6 col-lg-4">
						<div class="input-group input-group-sm shadow">
							<input type="file" ref="kkRef" class="form-control form-control-sm" accept="image/*" @change="handleInputFoto($event, 'kk')" :disabled="loadingInput.kk" />
							<span class="input-group-text" v-show="loadingInput.kk">
								<span class="spinner-border spinner-border-sm text-secondary"></span>
							</span>
						</div>
						<img
							v-show="previews.kk"
							:src="previews.kk"
							style="max-width: 100%; max-height: 160px"
							class="mt-2 shadow btn btn-outline-secondary p-1"
							alt=""
							data-bs-toggle="modal"
							data-bs-target="#lihatFoto"
							@click="lihatFoto = previews.kk"
							v-tooltip="'Lihat Foto'" />
					</div>
				</div>
				<div class="row mb-2">
					<label class="col-sm-4 col-md-3 col-lg-2 col-form-label col-form-label-sm">Akta Kelahiran</label>
					<div class="col-sm-6 col-lg-4">
						<div class="input-group input-group-sm shadow">
							<input type="file" ref="aktaRef" class="form-control form-control-sm" accept="image/*" @change="handleInputFoto($event, 'akta')" :disabled="loadingInput.akta" />
							<span class="input-group-text" v-show="loadingInput.akta">
								<span class="spinner-border spinner-border-sm text-secondary"></span>
							</span>
						</div>
						<img
							v-show="previews.akta"
							:src="previews.akta"
							style="max-width: 100%; max-height: 160px"
							class="mt-2 shadow btn btn-outline-secondary p-1"
							alt=""
							data-bs-toggle="modal"
							data-bs-target="#lihatFoto"
							@click="lihatFoto = previews.akta"
							v-tooltip="'Lihat Foto'" />
					</div>
				</div>
				<div class="row mb-2">
					<label class="col-sm-4 col-md-3 col-lg-2 col-form-label col-form-label-sm">
						SKL/Ijazah <i class="rounded rounded-circle text-bg-secondary px-1 small" v-tooltip="'Ijazah SMP/MTs atau SD/MI'">i</i>
					</label>
					<div class="col-sm-6 col-lg-4">
						<div class="input-group input-group-sm shadow">
							<input type="file" ref="sklRef" class="form-control form-control-sm" accept="image/*" @change="handleInputFoto($event, 'skl')" :disabled="loadingInput.skl" />
							<span class="input-group-text" v-show="loadingInput.skl">
								<span class="spinner-border spinner-border-sm text-secondary"></span>
							</span>
						</div>
						<img
							v-show="previews.skl"
							:src="previews.skl"
							style="max-width: 100%; max-height: 160px"
							class="mt-2 shadow btn btn-outline-secondary p-1"
							alt=""
							data-bs-toggle="modal"
							data-bs-target="#lihatFoto"
							@click="lihatFoto = previews.skl"
							v-tooltip="'Lihat Foto'" />
					</div>
				</div>
				<div class="row mb-2">
					<label class="col-sm-4 col-md-3 col-lg-2 col-form-label col-form-label-sm">KTP Ayah</label>
					<div class="col-sm-6 col-lg-4">
						<div class="input-group input-group-sm shadow">
							<input
								type="file"
								ref="ktpAyahRef"
								class="form-control form-control-sm"
								accept="image/*"
								@change="handleInputFoto($event, 'ktpAyah')"
								:disabled="loadingInput.ktpAyah" />
							<span class="input-group-text" v-show="loadingInput.ktpAyah">
								<span class="spinner-border spinner-border-sm text-secondary"></span>
							</span>
						</div>
						<img
							v-show="previews.ktpAyah"
							:src="previews.ktpAyah"
							style="max-width: 100%; max-height: 160px"
							class="mt-2 shadow btn btn-outline-secondary p-1"
							alt=""
							data-bs-toggle="modal"
							data-bs-target="#lihatFoto"
							@click="lihatFoto = previews.ktpAyah"
							v-tooltip="'Lihat Foto'" />
					</div>
				</div>
				<div class="row mb-2">
					<label class="col-sm-4 col-md-3 col-lg-2 col-form-label col-form-label-sm">KTP Ibu</label>
					<div class="col-sm-6 col-lg-4">
						<div class="input-group input-group-sm shadow">
							<input
								type="file"
								ref="ktpIbuRef"
								class="form-control form-control-sm"
								accept="image/*"
								@change="handleInputFoto($event, 'ktpIbu')"
								:disabled="loadingInput.ktpIbu" />
							<span class="input-group-text" v-show="loadingInput.ktpIbu">
								<span class="spinner-border spinner-border-sm text-secondary"></span>
							</span>
						</div>
						<img
							v-show="previews.ktpIbu"
							:src="previews.ktpIbu"
							style="max-width: 100%; max-height: 160px"
							class="mt-2 shadow btn btn-outline-secondary p-1"
							alt=""
							data-bs-toggle="modal"
							data-bs-target="#lihatFoto"
							@click="lihatFoto = previews.ktpIbu"
							v-tooltip="'Lihat Foto'" />
					</div>
				</div>
				<div class="row mb-2">
					<label class="col-sm-4 col-md-3 col-lg-2 col-form-label col-form-label-sm">KTP Wali</label>
					<div class="col-sm-6 col-lg-4">
						<div class="input-group input-group-sm shadow">
							<input
								type="file"
								ref="ktpWaliRef"
								class="form-control form-control-sm"
								accept="image/*"
								@change="handleInputFoto($event, 'ktpWali')"
								:disabled="loadingInput.ktpWali" />
							<span class="input-group-text" v-show="loadingInput.ktpWali">
								<span class="spinner-border spinner-border-sm text-secondary"></span>
							</span>
						</div>
						<img
							v-show="previews.ktpWali"
							:src="previews.ktpWali"
							style="max-width: 100%; max-height: 160px"
							class="mt-2 shadow btn btn-outline-secondary p-1"
							alt=""
							data-bs-toggle="modal"
							data-bs-target="#lihatFoto"
							@click="lihatFoto = previews.ktpWali"
							v-tooltip="'Lihat Foto'" />
					</div>
				</div>
			</div>
		</div>
		<div class="card-footer text-end" v-show="pendaftar">
			<input type="submit" class="btn btn-primary px-4" value="Simpan" />
		</div>
	</form>
	<div class="modal fade" id="lihatFoto" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-xl modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<legend class="modal-title">Lihat Foto</legend>
					<button type="button" id="tutupLihatFoto" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<img v-show="lihatFoto" :src="lihatFoto" class="w-100" alt="Preview" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import WebSocketService from "./WebSocketService";

export default {
	data() {
		return {
			listTa: [],
			ta: this.$store.getters.getTahunAjaran,
			listPendaftar: [],
			pendaftar: null,
			kelengkapan: 0,
			files: {
				fotoDiri: null,
				kk: null,
				akta: null,
				skl: null,
				ktpAyah: null,
				ktpIbu: null,
				ktpWali: null,
			},
			previews: {
				fotoDiri: null,
				kk: null,
				akta: null,
				skl: null,
				ktpAyah: null,
				ktpIbu: null,
				ktpWali: null,
			},
			loadingInput: {
				fotoDiri: null,
				kk: null,
				akta: null,
				skl: null,
				ktpAyah: null,
				ktpIbu: null,
				ktpWali: null,
			},
			lihatFoto: null,
			pendaftaranListener: (data) => {
				const d = JSON.parse(data);
				if (d.tahun_ajaran_id == this.ta.tahun_ajaran_id) {
					this.getListPendaftar();
				}
			},
			berkasListener: (data) => {
				const d = JSON.parse(data);
				if (d.ppdb_id == this.pendaftar?.ppdb_id) {
					this.getBerkasPendaftar();
				}
			},
		};
	},
	computed: {
		token() {
			return this.$store.getters.getToken;
		},
		user() {
			return this.$store.getters.getUserData;
		},
		adminKhusus() {
			return String(this.user.ket)
				.split(",")
				.some((k) => {
					return ["it", "ppdb-khusus"].includes(k);
				});
		},
		warna() {
			if (this.kelengkapan == 0) {
				return "#000";
			} else if (this.kelengkapan < 33) {
				return "red";
			} else if (this.kelengkapan < 66) {
				return "orange";
			} else if (this.kelengkapan < 100) {
				return "#5394fd";
			} else {
				return "green";
			}
		},
	},
	watch: {
		ta() {
			this.getListPendaftar();
		},
		pendaftar(val) {
			for (let field in this.files) {
				this.files[field] = null;
				this.previews[field] = null;
				this.loadingInput[field] = null;
				this.$refs[field + "Ref"].value = null;
			}
			this.kelengkapan = 0;
			if (val) {
				this.getBerkasPendaftar();
			}
		},
	},
	mounted() {
		this.getListTa();
		this.getListPendaftar();
		WebSocketService.on("inserted-ppdb", this.pendaftaranListener);
		WebSocketService.on("updated-ppdb", this.pendaftaranListener);
		WebSocketService.on("deleted-ppdb", this.pendaftaranListener);
		WebSocketService.on("inserted-berkas", this.berkasListener);
		WebSocketService.on("updated-berkas", this.berkasListener);
	},
	beforeUnmount() {
		WebSocketService.off("inserted-ppdb", this.pendaftaranListener);
		WebSocketService.off("updated-ppdb", this.pendaftaranListener);
		WebSocketService.off("deleted-ppdb", this.pendaftaranListener);
		WebSocketService.off("inserted-berkas", this.berkasListener);
		WebSocketService.off("updated-berkas", this.berkasListener);
	},
	methods: {
		async getListTa() {
			try {
				const response = await this.axios.post(
					"/list/tahun-ajaran",
					{},
					{
						headers: { Authorization: this.token },
					}
				);
				if (response.data) {
					this.listTa = response.data.tahun_ajaran;
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
					}
				} else {
					console.log(err);
				}
			}
		},
		async handleInputFoto(event, type) {
			this.loadingInput[type] = true;

			const file = event.target.files[0];
			if (file && file.type.startsWith("image/")) {
				const maxFileSizeMB = 2;
				const maxFileSizeByte = maxFileSizeMB * 1024 * 1024;
				if (file.size > maxFileSizeByte) {
					this.loadingInput[type] = false;
					return this.$swal({
						title: "Peringatan",
						text: `Ukuran file tidak boleh melebihi ${maxFileSizeMB}MB!`,
						icon: "warning",
						confirmButtonText: "Mengerti",
					}).then(() => {
						this.$refs[type + "Ref"].value = null;
					});
				}
				setTimeout(() => {
					this.files[type] = file;
					this.previews[type] = URL.createObjectURL(file);
					this.loadingInput[type] = false;
				}, 250);
			} else {
				this.$swal({
					title: "Peringatan",
					text: "File yang Anda pilih bukan file Gambar. Silakan pilih jenis file yang sesuai!",
					icon: "warning",
					confirmButtonText: "Mengerti",
				}).then(() => {
					this.$refs[type + "Ref"].value = null;
					this.files[type] = null;
					this.previews[type] = null;
					this.loadingInput[type] = false;
				});
			}
		},
		async getListPendaftar() {
			try {
				const response = await this.axios.post(
					"/list/pendaftar",
					{
						tahun_ajaran_id: this.ta.tahun_ajaran_id,
					},
					{
						headers: { Authorization: this.token },
					}
				);
				if (response.data) {
					this.listPendaftar = response.data.pendaftar;
					for (const p of this.listPendaftar) {
						p.no_reg_nama = "(" + p.no_reg + ") " + p.nama;
					}
					const cekPendaftar = this.listPendaftar.some((p) => p.ppdb_id === this.pendaftar?.ppdb_id);
					if (!cekPendaftar) this.pendaftar = null;
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
					}
				} else {
					console.log(err);
				}
			}
		},
		async getBerkasPendaftar() {
			let memuat = this.$loading.show({
				container: this.$refs.formField,
				loader: "dots",
			});

			try {
				const response = await this.axios.post(
					"/berkas",
					{
						ppdb_id: this.pendaftar?.ppdb_id,
					},
					{
						headers: { Authorization: this.token },
					}
				);
				if (response.data) {
					const berkas = response.data.berkas;
					if (berkas) {
						for (let field in this.files) {
							this.files[field] = null;
							this.loadingInput[field] = null;
							this.$refs[field + "Ref"].value = null;
						}
						let terisi = 0;
						if (berkas.foto_diri) terisi++;
						if (berkas.kk) terisi++;
						if (berkas.akta) terisi++;
						if (berkas.skl) terisi++;
						if (berkas.ktp_ayah) terisi++;
						if (berkas.ktp_ibu) terisi++;
						if (berkas.ktp_wali) terisi++;
						this.kelengkapan = Math.round(((terisi / 7) * 100 + Number.EPSILON) * 100) / 100;
						this.previews = {
							fotoDiri: berkas.foto_diri,
							kk: berkas.kk,
							akta: berkas.akta,
							skl: berkas.skl,
							ktpAyah: berkas.ktp_ayah,
							ktpIbu: berkas.ktp_ibu,
							ktpWali: berkas.ktp_wali,
						};
					}
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
					}
				} else {
					console.log(err);
				}
			}

			setTimeout(() => {
				memuat.hide();
			}, 250);
		},
		async simpanData() {
			let fileTerpilih = 0;
			for (let i in this.files) {
				if (this.files[i]) {
					fileTerpilih++;
					break;
				}
			}
			if (!fileTerpilih) {
				return this.$swal({
					title: "Peringatan",
					text: `Anda belum memilih file untuk diunggah!`,
					icon: "warning",
					confirmButtonText: "Mengerti",
				});
			}

			let memuat = this.$loading.show({
				container: this.$refs.formUnggah,
				loader: "spinner",
			});

			const formData = new FormData();
			formData.append("ppdb_id", this.pendaftar?.ppdb_id);
			if (this.files.fotoDiri) formData.append("foto_diri", this.files.fotoDiri);
			if (this.files.kk) formData.append("kk", this.files.kk);
			if (this.files.akta) formData.append("akta", this.files.akta);
			if (this.files.skl) formData.append("skl", this.files.skl);
			if (this.files.ktpAyah) formData.append("ktp_ayah", this.files.ktpAyah);
			if (this.files.ktpIbu) formData.append("ktp_ibu", this.files.ktpIbu);
			if (this.files.ktpWali) formData.append("ktp_wali", this.files.ktpWali);

			try {
				const response = await this.axios.post("/berkas/tambah", formData, {
					headers: { Authorization: this.token, "Content-Type": "multipart/form-data" },
				});
				if (response.data) {
					this.$swal({
						title: "Sukses",
						text: response.data.message,
						icon: "success",
						showConfirmButton: false,
						timer: 1500,
					});
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
						this.$swal({
							title: "Gagal",
							html: `<p class="text-danger">${err.response.data.error}</p>
                    <code class="text-secondary text-bg-secondary bg-opacity-10">code: ${err.response.data.code}<br/>
                    message: ${err.response.data.message}</code>`,
							icon: "error",
							confirmButtonText: "Baik",
						});
					}
				} else {
					console.log(err);
				}
			}

			setTimeout(() => {
				memuat.hide();
			}, 250);
		},
	},
};
</script>

<style></style>
